import React from 'react';
import './footer.scss';


const Footer = () => {
  return (
    <footer className='footer-wrap f-center'>
      <div className='f-container'>
        <div className='f-row'>
          <div className='f-item f-item-6 f-start f-clear-margin-t-b'>
            <span>© 2018-{new Date().getFullYear()} gasup.in.ua All rights reserved.</span>
          </div>
          <div className='f-item f-item-6 f-end f-clear-margin-t-b' />
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/client/components/footer/footer.jsx